import { ButtonLink, Card, CardContent, CardHeader, CardTitle } from '@shared/components';
import type { FundAccountCardModel } from '../../../hooks/useFundAccountsSection';
import { FundAccountStatementBody } from './FundAccountStatementBody';

export function FundAccountStatementCard(props: FundAccountCardModel) {
    return (
        <Card ariaLabelledBy={props.state === 'none' ? undefined : 'fund-account-statement-heading'}>
            {props.state !== 'none' && (
                <CardHeader>
                    <div className="flex flex-wrap items-center justify-between gap-2">
                        <CardTitle id="fund-account-statement-heading">{props.title}</CardTitle>
                        {props.detailsHref && (
                            <ButtonLink to={props.detailsHref} variant="primary" appearance="outline" size="xs">
                                More details
                            </ButtonLink>
                        )}
                    </div>
                    {props.datesLine && <p className="text-sm text-mp-muted">{props.datesLine}</p>}
                </CardHeader>
            )}
            <CardContent>
                <FundAccountStatementBody {...props} />
            </CardContent>
        </Card>
    );
}
